import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { PermissionsFacade } from '../../facade/permissions.facade';
import { Access } from '../../models/Acces.model';
import { DeleteAccess } from '../../models/deleteAccess.model';
import { GrantAccess } from '../../models/grantAccess.model';
import { UpdateAccessOnAsset } from '../../models/updateAccessOnAsset.model';
import { User } from '../../models/user.model';
import { DeleteAccessComponent } from '../dialogs/delete-access/delete-access.component';
import {DefaultPermissions} from '../../models/defaultPermissions.model';
import {combineLatest, fromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, tap} from 'rxjs/operators';
import {Asset} from '../../../../../main/modules/asset/models/asset.model';
import {environment} from '../../../../../../../environments/environment';

@Component({
  selector: 'morva-dashboard-group-permission',
  templateUrl: './dashboard-group-permission.component.html',
  styleUrls: ['../styles.scss'],
})
export class DashboardGroupPermissionComponent implements OnInit {
  totalPage: number;
  pageNumber: number;
  asset: Asset;
  addUserMode = false;
  users = [];
  newAccessUsers = [];
  defaultRoles: any[] = [];
  defaultPermissions = {
    dashboard: new DefaultPermissions().filter('Dashboard'),
    dashboardGroup: new DefaultPermissions().filter('DashboardGroup'),
  };
  permissionsSelect: any = [];
  permissionsTemp = {
    dashboard: new DefaultPermissions().filter('Dashboard'),
    dashboardGroup: new DefaultPermissions().filter('DashboardGroup'),
  };
  profileForm = new UntypedFormGroup({
    userRole: new UntypedFormControl('سفارشی', Validators.required),
    user: new UntypedFormControl('', Validators.required),
    permission: new UntypedFormControl('',Validators.required),
  });
  assetId: any;
  workspaceId: any;
  isInit = true;
  tabType: any;
  subscriptions = [];
  loading: boolean;
  helpURL = `${environment.api}/File/Download?path=058d03e3-9abd-409f-8ad2-4cfba8d189a2/` +
    'ApplicationFiles/b1cacb55-6d49-4a81-8b76-524fce18a976.pdf';

  constructor(
    protected dialogRef: NbDialogRef<any>,
    private dialogService: NbDialogService,
    private permissionsFacade: PermissionsFacade) {}

  @ViewChild('searchKeyUser') set inputUser(inputUser: ElementRef){
    if(inputUser) {
      fromEvent(inputUser.nativeElement,'keyup')
          .pipe(
              filter(Boolean),
              debounceTime(500),
              distinctUntilChanged(),
              tap(() => {
                const searchKey = inputUser.nativeElement.value;
                this.searchUser(searchKey);
              }),
          )
          .subscribe();
    }
  };

  ngOnInit(): void {
    this.loading = true;
    this.assetId = this.asset.assetId;
    this.permissionsFacade.updatePageNumber(1);
    this.profileForm.controls.userRole.disable();
    this.loadUsersAndGroups();
    this.setSubscribers();
  }

  loadUsersAndGroups() {
    this.permissionsFacade.loadUsersAndUserGroupsDashboardGroup('DashboardGroup', this.workspaceId, this.assetId);
    this.tabType = 0;
  }

  setSubscribers() {
    this.permissionsFacade.getNewAccessDashboardGroup$().
    subscribe((newAccessUsers: any) => this.newAccessUsers = newAccessUsers);

    this.subscriptions.
    push(this.permissionsFacade.getUsers$().pipe(tap( (users: User[]) => this.users = users)));
    this.subscriptions.
    push(this.permissionsFacade.getDefaultAccess$().pipe(tap(defaultRoles => this.defaultRoles = defaultRoles)));
    this.subscriptions.
    push(this.permissionsFacade.getTotalPages$().pipe(tap((totalPage: number) => this.totalPage = totalPage)));
    this.subscriptions.
    push(this.permissionsFacade.getPageNumber$().pipe(tap((pageNumber: number) => this.pageNumber = pageNumber)));

    combineLatest(this.subscriptions).subscribe(() => this.loading = false);
  }

  changeTabset($event) {
    if($event.tabId === '0' && !this.isInit) {
      this.tabType = 0;
    }
    if($event.tabId === '1') {
      this.isInit = false;
      this.tabType = 1;
    }
  }

  changePageNumber(pageNumber: number) {
    this.permissionsFacade.updatePageNumber(pageNumber);
    this.permissionsFacade.updateUsersDashboardGroup('DashboardGroup', this.workspaceId, this.assetId,pageNumber);
  }

  changeRole(roleId: string, userIndex: number) {
    this.permissionsSelect = {
      dashboard: this.defaultRoles[1].find(role => role.id === roleId).permissions,
      dashboardGroup: this.defaultRoles[0].find(role => role.id === roleId).permissions,
    };

    const permissions = {
      dashboard: new DefaultPermissions().mapSpecificPermissions(
        this.permissionsSelect.dashboard,'Dashboard',false),
      dashboardGroup: new DefaultPermissions().mapSpecificPermissions(
        this.permissionsSelect.dashboardGroup,'DashboardGroup',false),
    };
    this.permissionsFacade.updateUserPermissions(roleId, userIndex, permissions,true);
    const access = new Access(
      this.users[userIndex].id,
      this.users[userIndex].accessRecipientId,
      this.users[userIndex].accessRecipientType,
      false,
      true,
      roleId);
    const newAccess = new UpdateAccessOnAsset(this.workspaceId, this.assetId, 'DashboardGroup', access);
    this.permissionsFacade.updateDashboardGroup(newAccess);
  }

  changePermissionDashboardGroup(isChecked: boolean, enName: string, userIndex: number): void {
    let permissionsSelected = {
      dashboard: new Map
      (JSON.parse(JSON.stringify(Array.from(this.users[userIndex].permissionsSelected.dashboard)))),
      dashboardGroup: new Map
      (JSON.parse(JSON.stringify(Array.from(this.users[userIndex].permissionsSelected.dashboardGroup)))),
    };
    permissionsSelected =  this.checkViewAccess(isChecked, enName, permissionsSelected, 'DashboardGroup');
    const permissions = this.mapPermissions(permissionsSelected);

    this.permissionsFacade.
    updateUserPermissions('', userIndex, permissionsSelected, false);
    const access = new Access(
      this.users[userIndex].id,
      this.users[userIndex].accessRecipientId,
      this.users[userIndex].accessRecipientType,
      false,
      false,
      permissions.dashboardGroup.concat(permissions.dashboard));
    const newAccess = new UpdateAccessOnAsset(this.workspaceId, this.assetId, 'DashboardGroup', access);
    this.permissionsFacade.updateDashboardGroup(newAccess);
  }

  changePermissionDashboard(isChecked: boolean, enName: string, userIndex: number): void {
    let permissionsSelected = {
      dashboard: new Map
      (JSON.parse(JSON.stringify(Array.from(this.users[userIndex].permissionsSelected.dashboard)))),
      dashboardGroup: new Map
      (JSON.parse(JSON.stringify(Array.from(this.users[userIndex].permissionsSelected.dashboardGroup)))),
      };
    permissionsSelected =  this.checkViewAccess(isChecked, enName, permissionsSelected, 'Dashboard');
    const permissions = this.mapPermissions(permissionsSelected);

    this.permissionsFacade.
    updateUserPermissions('', userIndex, permissionsSelected, false);
    const access = new Access(
      this.users[userIndex].id,
      this.users[userIndex].accessRecipientId,
      this.users[userIndex].accessRecipientType,
      false,
      false,
      permissions.dashboardGroup.concat(permissions.dashboard));
    const newAccess = new UpdateAccessOnAsset(this.workspaceId, this.assetId, 'DashboardGroup', access);
    this.permissionsFacade.updateDashboardGroup(newAccess);
  }

  mapPermissions(permissions: any): any {
    const result = {dashboard: [], dashboardGroup: []};
    permissions.dashboardGroup.forEach(permission => {
      if (permission.isChecked) {
        result.dashboardGroup.push(permission.id);
      }
    });
    permissions.dashboard.forEach(permission => {
      if (permission.isChecked) {
        result.dashboard.push(permission.id);
      }
    });
    return result;
  }
  closeDialog() {
    this.dialogRef.close();
  }

  loadNewUsers() {
    const body: GrantAccess = {
      workspaceId: this.workspaceId,
      assetId: this.assetId,
      assetType: 'DashboardGroup',
      searchKey: '',
    };
    this.permissionsFacade.loadForNewAccessDashboardGroupWithDebounce(body);

  }

  searchUser(searchKey) {
    const body: GrantAccess = {
      workspaceId: this.workspaceId,
      assetId: this.assetId,
      assetType: 'DashboardGroup',
      searchKey,
    };
    this.permissionsFacade.loadForNewAccessDashboardGroupWithDebounce(body);
    this.permissionsTemp = {
      dashboard: new DefaultPermissions().filter('Dashboard'),
      dashboardGroup: new DefaultPermissions().filter('DashboardGroup'),
    };
    this.changeUserRole(undefined);
    this.profileForm.patchValue({
      userRole: 'سفارشی',
      permission: null,
    });
  }

  viewHandle(user: any) {
    if(user.id) {
      if(user.userType === 'Group') {
        return user.groupName;
      }
      return (user.firstName + ' ' + user.lastName);
    }
    return user;
  }

  changeUserRole($event): void {
    if($event) {
      this.profileForm.controls.userRole.enable();
    } else {
      this.profileForm.controls.userRole.disable();
    }
  }

  changeDefaultAccess(roleId: string) {
    if(this.profileForm.value.user) {
      const selectRoleDashboardGroup = this.defaultRoles[0].find(role => role.id === roleId);
      const selectRoleDashboard = this.defaultRoles[1].find(role => role.id === roleId);

      this.permissionsTemp = {
        dashboard: new DefaultPermissions().
        mapSpecificPermissions(selectRoleDashboard.permissions,'Dashboard',false),
        dashboardGroup: new DefaultPermissions()
          .mapSpecificPermissions(selectRoleDashboardGroup.permissions,'DashboardGroup',false),
      };
      this.profileForm.patchValue({
        permission: this.permissionsTemp,
      });
    }
  }

  changeAccess(isChecked: boolean, enName: string) {
    if(this.tabType === 0 ) {
      this.permissionsTemp = this.checkViewAccess(isChecked,enName,this.permissionsTemp,'DashboardGroup');
    } else {
      this.permissionsTemp = this.checkViewAccess(isChecked,enName,this.permissionsTemp,'Dashboard');
    }
    this.profileForm.patchValue({
      userRole: 'سفارشی',
      permission: this.permissionsTemp,
    });
  }

  onAddUserClicK() {
    this.addUserMode = true;
    this.loadNewUsers();
  }

  closeAddUser() {
    this.addUserMode = false;
    this.resetProfileForm();
  }

  onSaveUserClick() {
    const data = this.profileForm.value;
    const permissions = this.mapPermissions(data.permission);
    const access = new Access(
      data.user.id,
      data.user.userType,
      true,
      data.userRole !== 'سفارشی',
      data.userRole !== 'سفارشی' ? data.userRole :
        permissions.dashboard.concat(permissions.dashboardGroup));
    const body = new UpdateAccessOnAsset(this.workspaceId, this.assetId, 'DashboardGroup', access);

    this.permissionsFacade.updateDashboardGroup(body);
    this.tabType = 0;
    this.resetProfileForm();
    this.closeAddUser();
  }

  resetProfileForm() {
    this.permissionsTemp = {
      dashboard: new DefaultPermissions().filter('Dashboard'),
      dashboardGroup: new DefaultPermissions().filter('DashboardGroup'),
    };
    this.profileForm.patchValue({
      userRole: 'سفارشی',
      user: '',
      permission: null,
    });
  }

  openDeleteDialog(user: User) {
    const accessType = 'DashboardGroup';
    this.dialogService.open(DeleteAccessComponent, {context: {user,accessType}}).
    onClose.subscribe((isDelete) => {
      if(isDelete) {
        const body: DeleteAccess = {
          workspaceId: this.workspaceId,
          assetId: this.assetId,
          accessId: user.id,
          accessRecipientId: user.accessRecipientId,
          assetType: 'DashboardGroup',
          userType: user.accessRecipientType,
        };
        this.permissionsFacade.deleteUserAccess(body);
      }
    });
  }

  checkViewAccess(isChecked: boolean, enName: string, permissions: any, type: string): any {
    if(enName !== 'View' && isChecked) {
      permissions.dashboardGroup.get('View').isChecked = isChecked;
      if(type === 'DashboardGroup') {
        permissions.dashboardGroup.get(enName).isChecked = isChecked;
      } else {
        permissions.dashboard.get('View').isChecked = isChecked;
        permissions.dashboard.get(enName).isChecked = isChecked;
      }
    } else if (enName !== 'View' && !isChecked) {
      if(type === 'DashboardGroup') {
        permissions.dashboardGroup.get(enName).isChecked = isChecked;
      } else {
        permissions.dashboard.get(enName).isChecked = isChecked;
      }
    } else if (enName === 'View' && isChecked) {
      permissions.dashboardGroup.get('View').isChecked = isChecked;
      if(type !== 'DashboardGroup') {
        permissions.dashboard.get('View').isChecked = isChecked;
      }
    } else if (enName === 'View' && !isChecked) {
      if(type === 'DashboardGroup') {
        permissions.dashboardGroup = new DefaultPermissions().filter('DashboardGroup');
      }
      permissions.dashboard = new DefaultPermissions().filter('Dashboard');
    }
    return permissions;
  }
}
